import { useState } from 'react'
import { P2, Icon } from '@moneymade/moneymade-ui'
import PropTypes from 'prop-types'

import InfoModal from 'modules/discover/PlatformPageNew/Snapshot/InfoModal/InfoModal'
import styles from './AccreditedText.module.scss'

const AccreditedText = ({ investors, text }) => {
  const [isModal, setModal] = useState(false)

  return (
    <>
      {isModal && (
        <InfoModal
          isOpen={isModal}
          data={{ title: investors === 'All' ? 'All Investors' : 'Accredited Investor', text }}
          handleClose={() => setModal(false)}
        />
      )}

      <div className={styles.Accredited}>
        <P2 weight="normal">
          {investors === 'All'
            ? 'Open to All Investors'
            : investors === 'US'
            ? 'Open to US Investors'
            : investors === 'Non-US'
            ? 'Open to Non-US Investors'
            : 'Open to Accredited Investors'}
        </P2>

        {text && (
          <button type="button" className={styles.InfoBtn} onClick={() => setModal(true)}>
            <Icon icon="icon-info" size={14} />
          </button>
        )}
      </div>
    </>
  )
}

AccreditedText.propTypes = {
  investors: PropTypes.string,
  text: PropTypes.string
}

AccreditedText.defaultProps = {
  investors: '',
  text: ''
}

export default AccreditedText
